import type { AdminRouterContext } from '@/lib/router-context'
import type { WiredOrdersReportSearch } from '@/lib/services/reports/reports.schema'
import { wiredOrdersReportSearchSchema } from '@/lib/services/reports/reports.schema'
import { createFileRoute, notFound, redirect } from '@tanstack/react-router'

export const legacyWiredOrdersLoader = ({
  context,
  deps: { search },
  params,
}: {
  context: Pick<AdminRouterContext, 'ability'>
  deps: { search: WiredOrdersReportSearch }
  params: { orgId: number }
}): never => {
  if (!context.ability.can('list', 'transactions')) throw notFound()

  throw redirect({
    to: '/$orgId/reports/external-orders',
    params: { orgId: params.orgId },
    search: {
      ...search,
      source_system: 'fsn_network',
    },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/reports/wired-orders')({
  validateSearch: (search) => wiredOrdersReportSearchSchema.parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: legacyWiredOrdersLoader,
})
